module.exports = __webpack_public_path__ + "img/view_fill_form_icon.8c0f3028.svg";